export function configLibraries() {
  // // Lightbox
  // lightbox.option({
  //   showImageNumberLabel: false,
  // });
}
